<div class="agenda">
    <div class="agenda__title" v-html="$t('profile.agenda.title')"></div>
    <div class="agenda__scheme">
        <div class="agenda__scheme-row">
            <span>{{ $t('profile.agenda.days.hours') }}</span>
            <span>
                <i v-for="hour in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]">
                    {{ hour }}
                </i>
            </span>
        </div>
        <div class="agenda__scheme-row" v-for="day in [0,1,2,3,4,5,6]">
            <span>{{ $t('profile.agenda.days.d'+ day) }}</span>
            <span>
                <i v-for="hour in hourList[day]" :class="'c c' + hour"></i>
            </span>
        </div>
    </div>
    <div class="agenda__top fa-solid fa-caret-up" @click="scrollTop()"></div>
</div>